<template>
  <el-dialog
    class="import-dialog"
    :append-to-body="true"
    :visible="dialogShow"
    title="批量导入"
    width="640px"
    :before-close="handleClose"
  >
    <import-form
      ref="outform"
      @submit="submit"
    ></import-form>
    <div slot="footer" class="dialog-footer">
      <el-button
        :loading="loading"
        type="primary"
        @click.stop="doSubmit"
      >确认并发送通知</el-button>
    </div>
  </el-dialog>
</template>

<script>

import importForm from "./importForm";
export default {
    name: "importDialog",
    components: {
      importForm
    },
    props: {
        dialogShow: {
            type: Boolean,
            default: false
        },
    },
  data() {
    return {
      title: '批量导入',
      loading: false,
    }
  },
    methods: {
        handleClose() {
          this.$emit('close');
          this.$refs.outform.selfClear();
        },
        doSubmit(){
            this.$refs.outform.selfValidate();
        },
      submit(form){
        // 上传
        this.loading = true;
        let urls = [];
        for (let i = 0; i < form.fileList.length; i++) {
          urls.push(form.fileList[i].url);
        }
        // let params = ;
        this.$http({
          url: '/wx/manage/authorization/batchCreate',
          method: 'post',
          data: urls
        }).then((data) => {
          if (data && data.code === 200) {
            this.$message({
              type: 'success',
              message: '上传成功',
            });
            this.handleClose();
            this.$emit('close');
            this.$emit('success');
          } else {
          }
          this.loading = false
        })
      }
    },
}
</script>
<style lang="scss">
.import-dialog {
  .sidebar-content {
    text-align: center;
  }
  .el-dialog__header {
    background-color: #F8F8F8;
    padding-bottom: 20px;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-dialog__body {
    text-align: center;
  }
}
</style>
